import { render, staticRenderFns } from "./EditProjectPage.vue?vue&type=template&id=73308a03&"
import script from "./EditProjectPage.vue?vue&type=script&lang=js&"
export * from "./EditProjectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports